import { useState } from "react";
import api from "../../api/axios";

const CrawlPage = () => {
  const workspaceId = "eca5db98-571b-4735-81b4-505676753b64";

  const [url, setUrl] = useState("");
  const [mode, setMode] = useState("single");
  const [verification, setVerification] = useState(null);
  const [job, setJob] = useState(null);

  const verifySitemap = async () => {
    const res = await api.post("/crawl/verify", {
      workspaceId,
      url,
    });

    setVerification(res.data);
  };

  const startCrawl = async () => {
    const res = await api.post("/crawl/start", {
      workspaceId,
      baseUrl: url,
      urls: verification.sample,
    });

    setJob(res.data.jobId);
    pollStatus(res.data.jobId);
  };

  const pollStatus = async (jobId) => {
    const interval = setInterval(async () => {
      const res = await api.get(`/crawl/status/${jobId}`);
      setJob(res.data);

      if (res.data.status === "completed") {
        clearInterval(interval);
      }
    }, 3000);
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow-sm">
        <h4>Website Import</h4>

        <input
          className="form-control mb-3"
          placeholder="https://example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />

        <div className="mb-3">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              checked={mode === "single"}
              onChange={() => setMode("single")}
            />
            <label className="form-check-label">
              Single Page
            </label>
          </div>

          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              checked={mode === "site"}
              onChange={() => setMode("site")}
            />
            <label className="form-check-label">
              All Subpages (Sitemap)
            </label>
          </div>
        </div>

        {mode === "site" && (
          <button className="btn btn-secondary" onClick={verifySitemap}>
            Verify Sitemap
          </button>
        )}

        {verification?.hasSitemap && (
          <div className="alert alert-info mt-3">
            Found {verification.totalUrls} pages.
            <button
              className="btn btn-primary ms-3"
              onClick={startCrawl}
            >
              Confirm & Start Crawl
            </button>
          </div>
        )}

        {job && (
          <div className="mt-4">
            <div className="progress">
              <div
                className="progress-bar"
                style={{
                  width:
                    (job.processed_urls / job.total_urls) * 100 + "%",
                }}
              ></div>
            </div>
            <p className="mt-2">
              {job.processed_urls} / {job.total_urls}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CrawlPage;
